var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientIconWhite = function SvgPatientIconWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7266 10.2943C14.7266 11.5061 13.7442 12.4885 12.5324 12.4885C11.3206 12.4885 10.3382 11.5061 10.3382 10.2943C10.3382 9.08246 11.3206 8.1001 12.5324 8.1001C13.7442 8.1001 14.7266 9.08246 14.7266 10.2943ZM16.4144 15.0202C16.4144 16.232 14.6764 17.2144 12.5324 17.2144C10.3884 17.2144 8.65039 16.232 8.65039 15.0202C8.65039 13.8084 10.3884 12.826 12.5324 12.826C14.6764 12.826 16.4144 13.8084 16.4144 15.0202ZM13.1177 14.3974C13.302 14.2038 13.6008 14.2038 13.7851 14.3974L14.0724 14.6809C14.0979 14.706 14.1397 14.706 14.1652 14.6809L14.4525 14.3974C14.6368 14.2038 14.9356 14.2038 15.1199 14.3974C15.3041 14.591 15.3041 14.9048 15.1199 15.0984L14.2383 16.0243C14.1738 16.092 14.0637 16.092 13.9993 16.0243L13.1177 15.0984C12.9334 14.9048 12.9334 14.591 13.1177 14.3974Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "patient-icon-white.3616451bcde8bb8191b82893b253c767.svg";